// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2SZOf","inner":"Footer_inner__1bFez"};